import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=6abdba3e&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=6abdba3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abdba3e",
  null
  
)

export default component.exports